import makeService from './api';

export default makeService('industrial_computers');
